import classNames from 'classnames';
import React from 'react';
import './Row.scss';
import IRowProps from './RowProps';

const Row = ({ justify, align, direction, gutter, forwardRef, children, className }: IRowProps) => {
  const classes = classNames(
    {
      'row': true,
      'row-direction-column': direction === 'column',
      [`row-gutter-${gutter}`]: gutter,
      [`row-justify-${justify}`]: justify,
      [`row-align-${align}`]: align,
    },
    className
  );

  return (
    <div ref={forwardRef} className={classes}>
      {children}
    </div>
  );
};

export default Row;
